import "./style.scss";
import { Link } from "react-router-dom";
import { useLocation } from "react-router";

export default function StickyButtonNav({ items }) {
  const location = useLocation();

  return (
    <div className="sticky-button-nav-component">
      <div className="inner">
        {items.map((item, index) => {
          const isActive = item.active ?? item.link === location.pathname;

          return (
            <div key={index} className={`element ${isActive ? "active" : ""}`}>
              {item.action ? (
                <button type="button" onClick={item.action}>
                  <p>{item.label}</p>
                </button>
              ) : (
                <Link to={item.link}>
                  <p>{item.label}</p>
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
